export default __webpack_public_path__ + "static/media/arrow-right.e27b25c8.svg";